/**
 * @generated SignedSource<<d988b0a000aff373be8931d55518d3ba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TopicCommentsDeletedCommentSubscription$variables = {
  topicId: string;
};
export type TopicCommentsDeletedCommentSubscription$data = {
  readonly deletedComments: {
    readonly commentId: string;
    readonly parentId: string | null | undefined;
    readonly topicId: string;
  };
};
export type TopicCommentsDeletedCommentSubscription = {
  response: TopicCommentsDeletedCommentSubscription$data;
  variables: TopicCommentsDeletedCommentSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "topicId",
        "variableName": "topicId"
      }
    ],
    "concreteType": "DeletedComment",
    "kind": "LinkedField",
    "name": "deletedComments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "topicId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "parentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "commentId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicCommentsDeletedCommentSubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TopicCommentsDeletedCommentSubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "54b5e3a427d6292f2e252e1d840096ea",
    "id": null,
    "metadata": {},
    "name": "TopicCommentsDeletedCommentSubscription",
    "operationKind": "subscription",
    "text": "subscription TopicCommentsDeletedCommentSubscription(\n  $topicId: ID!\n) {\n  deletedComments(topicId: $topicId) {\n    topicId\n    parentId\n    commentId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c054b855bbf74f63a3d7ec5c7642edc";

export default node;
